/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 16:52:59
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-24 15:15:36
 * @FilePath: \hlweb2.0\src\pages\Home\Develop\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
function Develop() {
  const { t } = useTranslation();
  return (
    <div className="home_develop_" id="home_develop_id">
      <div className="home_develop_edition">
        <div className="edition_solution edition_solution_top">
          <div className="edition_solution_title">
            <div>{t("home.anchorPoint2")}</div>
            <span>{t("home.anchorPoint2Con.detail")}</span>
          </div>
        </div>
        <div className="home_develop_con">
          <div className="home_develop_con_bg">
            <img src={t("home.anchorPoint2Con.imgUrl", { returnObjects: true })} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Develop;
